
import React from 'react';
import { Play, Info } from 'lucide-react';

const GameHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="bg-gradient-to-r from-indigo-900 to-purple-800 py-16 md:py-24">
        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-blue-400 to-purple-400 mb-4 animate-pulse">
              Time Shooter 3 Unblocked
            </h1>
            <p className="text-xl md:text-2xl text-indigo-100 max-w-3xl mb-8">
              Experience intense SWAT action in this free online first-person shooter game
            </p>
            
            {/* SVG Badge */}
            <div className="w-32 h-32 mb-6">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="45" fill="#1A1F2C" stroke="#8B5CF6" strokeWidth="3"/>
                <path d="M30 50 L45 65 L70 35" stroke="#9b87f5" strokeWidth="6" fill="none"/>
                <text x="50" y="85" fontSize="12" fill="#D6BCFA" textAnchor="middle">SWAT FPS</text>
              </svg>
            </div>
            
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="#play-now" 
                className="flex items-center bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105 hover:shadow-lg"
              >
                <Play className="w-5 h-5 mr-2" />
                Play Now
              </a>
              <a 
                href="#game-guide" 
                className="flex items-center bg-transparent border-2 border-indigo-300 text-indigo-100 hover:bg-indigo-900 font-bold py-3 px-8 rounded-full transition-all transform hover:scale-105"
              >
                <Info className="w-5 h-5 mr-2" />
                Game Guide
              </a>
            </div>
          </div>
        </div>

        {/* Animated particles effect */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(15)].map((_, i) => (
            <div 
              key={i}
              className="absolute rounded-full bg-purple-600 opacity-20 animate-pulse"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${Math.random() * 15 + 5}px`,
                height: `${Math.random() * 15 + 5}px`,
                animationDuration: `${Math.random() * 5 + 2}s`,
                animationDelay: `${Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameHero;
